"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GqlRequestSource = void 0;
var GqlRequestSource;
(function (GqlRequestSource) {
    GqlRequestSource["SHEF_API"] = "shef-api";
    GqlRequestSource["CONSUMER_APP"] = "consumer-app";
    GqlRequestSource["RETOOL"] = "retool";
    GqlRequestSource["STORYBOOK"] = "storybook";
    GqlRequestSource["SHEF_WEB"] = "shef-web";
    GqlRequestSource["SHEF_NEXT"] = "shef-next";
})(GqlRequestSource = exports.GqlRequestSource || (exports.GqlRequestSource = {}));
//# sourceMappingURL=GqlRequestSource.js.map